export default "__VITE_ASSET__BRjEGktd__"